import { PageLayout } from "components";
import { DataObjectDuplicateSearch } from "containers";

const DataObjectDuplicateSearchPage = (props) => {
    return (
        <PageLayout
            mainContent={({ setBreadcrumbNavigationItems }) => {
                return <DataObjectDuplicateSearch setBreadcrumbNavigationItems={setBreadcrumbNavigationItems}></DataObjectDuplicateSearch>;
            }}
        ></PageLayout>
    );
};

export default DataObjectDuplicateSearchPage;
